import {
  IoLogoLinkedin,
  IoLogoGithub,
  IoLogoTwitter,
  IoMailOutline,
} from "react-icons/io5";

export const PERSONAL_INFO = {
  name: "Aditya Raj",
  role: "Full-Stack & Web3 Developer",
  email: "adiabhiraj141@gmail.com",
  location: "Rewari, Haryana, India",
  resumeUrl:
    "https://docs.google.com/document/d/1FuhTAMiHH_nTtiA28yzb6SbtU5xev_jkRabrtUWtvaU/edit?usp=sharing",
  status: "Open to Opportunities",
};

export const SOCIAL_LINKS = [
  {
    id: "linkedin",
    name: "LinkedIn",
    username: "in/adiabhiraj",
    handle: "adiabhiraj",
    url: "https://linkedin.com/in/adiabhiraj",
    icon: IoLogoLinkedin,
    actionText: "Send DM on LinkedIn",
    badgeText: "Professional DM",
    gradient: "from-blue-600/20 via-sky-600/10 to-transparent",
    borderColor: "hover:border-blue-500/50",
    iconColor: "text-blue-400",
    btnBg: "bg-blue-600 hover:bg-blue-500 shadow-blue-500/20",
    description: "Connect professionally or send a direct message.",
  },
  {
    id: "twitter",
    name: "Twitter / X",
    username: "@adi_abhi_raj",
    handle: "adi_abhi_raj",
    url: "https://x.com/adi_abhi_raj",
    icon: IoLogoTwitter,
    actionText: "Send DM on X",
    badgeText: "Quick DM",
    gradient: "from-sky-500/20 via-blue-500/10 to-transparent",
    borderColor: "hover:border-sky-400/50",
    iconColor: "text-sky-400",
    btnBg: "bg-sky-500 hover:bg-sky-400 shadow-sky-500/20",
    description: "Drop a quick DM or follow my latest tech updates.",
  },
  {
    id: "github",
    name: "GitHub",
    username: "adiabhiraj195",
    handle: "adiabhiraj195",
    url: "https://github.com/adiabhiraj195",
    icon: IoLogoGithub,
    actionText: "Visit GitHub",
    badgeText: "Code & Projects",
    gradient: "from-violet-600/20 via-purple-600/10 to-transparent",
    borderColor: "hover:border-violet-500/50",
    iconColor: "text-violet-400",
    btnBg: "bg-violet-600 hover:bg-violet-500 shadow-violet-500/20",
    description: "Explore my open source work, repositories, and contributions.",
  },
  {
    id: "email",
    name: "Email",
    username: "adiabhiraj141@gmail.com",
    handle: "adiabhiraj141@gmail.com",
    url: "mailto:adiabhiraj141@gmail.com",
    icon: IoMailOutline,
    actionText: "Send Email",
    badgeText: "Direct Mail",
    gradient: "from-emerald-600/20 via-teal-600/10 to-transparent",
    borderColor: "hover:border-emerald-500/50",
    iconColor: "text-emerald-400",
    btnBg: "bg-emerald-600 hover:bg-emerald-500 shadow-emerald-500/20",
    description: "Prefer email? Send me a message directly to my inbox.",
  },
];
